// import currentUser from '../store/userAttributes';

export default class Provider {
  constructor() {
    if (new.target === Provider) {
      throw new TypeError('Cannot construct Abstract instances directly');
    }
    if (typeof window === 'undefined') {
      throw new TypeError('Cannot construct Abstract instances directly');
    }
  }

  trackEvent = () => {
    console.log('running from super class. trackEvent ');
  };

  trackState = () => {
    console.log('running from super class. trackState ');
  };

  getUserInfo = () => {
  };
}
